import { When } from '@teamsparta/react';

import { createCDNUrl } from '@/lib/utils/url';
import {
  useGetVideoAndImageSource,
  useIsRendered,
} from '@/pages/hub/components/FlameBackGround/logic';

import * as S from './style';

export default function FlameBackGroundTemplate() {
  const { videoSource, videoThumbnailSource } = useGetVideoAndImageSource();
  const { isRendered } = useIsRendered();

  return (
    <S.Container>
      <When condition={isRendered}>
        <video
          src={createCDNUrl(videoSource)}
          autoPlay
          muted
          loop
          playsInline
          controls={false}
          controlsList='nodownload'
          poster={createCDNUrl(videoThumbnailSource)}
        />
      </When>
    </S.Container>
  );
}
